import $ from 'jquery'
import {Module} from '../plugins/_application'
import Siema from 'siema';

export default class LogoSlider extends Module {
  ready () {

	if($('.siema').length){
				
		const mySiema = new Siema({
			perPage: {
				320: 1,
				400: 2,
				580: 3,
				768: 4,
				1024: 5,
				1920: 6,
				2400: 8,
			},
			loop: true,
			duration: 200,
			onInit() { showSiema(); }
		});
		const prev = document.querySelector('.arrow-left-container');
		const next = document.querySelector('.arrow-right-container');
		
		prev.addEventListener('click', () => mySiema.prev());
		next.addEventListener('click', () => mySiema.next());
	
		function showSiema(){

			$('.loading-items-wrapper').addClass('hidden');
	
			let delay = 0;
	
			$('.siema-item').each(function(){
				const THIS_SLIDE = $(this);
				setTimeout(function(){
					$(THIS_SLIDE).addClass('visible');
				}, delay);
				delay += 60;
			});
		}

	}

  }
}